import React from "react";

const Error = (props) =>{
    return <h1>{props.message}</h1>
}

export default Error